"use client"

import {
  Select as ChakraSelect,
  Portal,
  createListCollection,
} from "@chakra-ui/react"
import * as React from "react"
import { Field } from "../ui/field"

export interface SelectItem {
  label: string
  value: string
}

export interface SelectProps {
  name: string
  label?: string
  placeholder?: string
  options: SelectItem[]
  value: string
  onChange: (value: string) => void
  isRequired?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement>
}

export const Select: React.FC<SelectProps> = ({
  name,
  label,
  placeholder = "옵션을 선택해 주세요.",
  options,
  value,
  onChange,
  isRequired,
  portalled = true,
  portalRef,
}) => {
  const collection = React.useMemo(
    () => createListCollection({ items: options }),
    [options]
  )

  const handleValueChange = (val: { items: SelectItem[] }) => {
    onChange(val.items[0]?.value ?? "")
  }

  const dropdownContent = (
    <ChakraSelect.Positioner>
      <ChakraSelect.Content>
        {options.map((option) => (
          <ChakraSelect.Item key={option.value} item={option}>
            {option.label}
            <ChakraSelect.ItemIndicator />
          </ChakraSelect.Item>
        ))}
      </ChakraSelect.Content>
    </ChakraSelect.Positioner>
  )

  return (
    <Field label={label} required={isRequired}>
      <ChakraSelect.Root
        name={name}
        collection={collection}
        value={value ? [value] : []}
        onValueChange={handleValueChange}
        size="sm"
        width="100%"
      >
        <ChakraSelect.HiddenSelect />

        {label && <ChakraSelect.Label>{label}</ChakraSelect.Label>}

        <ChakraSelect.Control>
          <ChakraSelect.Trigger>
            <ChakraSelect.ValueText placeholder={placeholder} />
          </ChakraSelect.Trigger>
          <ChakraSelect.IndicatorGroup>
            <ChakraSelect.Indicator />
          </ChakraSelect.IndicatorGroup>
        </ChakraSelect.Control>

        {portalled ? (
          <Portal container={portalRef}>{dropdownContent}</Portal>
        ) : (
          dropdownContent
        )}
      </ChakraSelect.Root>
    </Field>
  )
}
